module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAWklEQVRo3u3PwRGAMAwDQbWQJiiaomjJ9AAPx5PVzP21qapMbvR5AAAAgE0Az7rqa7nTFgAAAAAAAMB4QPMAAAAAAAAOByRpCwAAAAAAAGALwOQAAAAAAH71AkTIxpw8zGKIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/United-Arab-Emirates.png
// module id = 281
// module chunks = 0